import { AnyAction } from 'redux';
import { MindmapState } from '../schema';
import { 
  SET_MINDMAP,
  SET_MINDMAP_LOADING,
  SET_MINDMAP_ERROR
} from '../middleware';

const initialState: MindmapState = {
  data: null,
  loading: false,
  error: null
};

export const mindmapReducer = (
  state = initialState,
  action: AnyAction
): MindmapState => {
  switch (action.type) {
    case SET_MINDMAP:
      return {
        ...state,
        data: action.payload.data,
        loading: false,
        error: null
      };
    case SET_MINDMAP_LOADING:
      return {
        ...state,
        loading: action.payload.loading,
        error: null
      };
    case SET_MINDMAP_ERROR:
      return {
        ...state,
        loading: false,
        error: action.payload.error
      };
    default:
      return state;
  }
};